import  MainList from './MainList';

const ExplorerIndex = {
  MainList
};

export default ExplorerIndex;
